import { createSelector } from 'reselect';

const getHasLoaded = createSelector(
  (state) => state.discoverStepTwoExtraCollections.hasLoaded,
  (hasLoaded) => hasLoaded
);
const getCurrencyData = createSelector(
  (state) => state.discoverStepTwoExtraCollections.data.currency,
  (currency = {}) => currency
);
const getCollectionsData = createSelector(
  (state) =>
    state.discoverStepTwoExtraCollections.data.discoverStepTwoExtraCollections,
  (collections = []) => collections
);
const getPageCount = createSelector(
  (state) => state.discoverStepTwoExtraCollections.data.pageCount,
  (pageCount) => pageCount || 0
);

export default {
  getCollectionsData,
  getCurrencyData,
  getHasLoaded,
  getPageCount,
};
